<YCPage query={pageQuery}>
  <CardsPage {listName} {pathParams} {pageQuery} />
</YCPage>

<script lang='ts'>import YCPage from '../components/YCPage.svelte';
import 'svelte-google-analytics/src';
import CardsPage from '../components/cards/common/CardsPage.svelte';
export let f7route;
const listName = f7route.params.listName;
const pathParams = (f7route.params.path1) ? [f7route.params.path1] : undefined;
const pageQuery = f7route.query;
</script>
